<template>
  <div class="border rounded p-4 mb-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">Pagamento {{ indice + 1 }}</h6>
      <b-button
        v-if="removivel"
        size="sm"
        variant="outline-danger"
        :disabled="ocupado"
        @click="$emit('remover')"
        >Remover</b-button
      >
    </div>
    <b-row>
      <b-col md="4"
        ><b-form-group label="Meio de pagamento" :label-for="campo('meio')"
          ><b-form-select
            :id="campo('meio')"
            :value="value.tPag"
            :options="meios"
            :disabled="ocupado"
            @input="atualizar('tPag', $event)"
            required /></b-form-group
      ></b-col>
      <b-col md="2"
        ><b-form-group label="Condição" :label-for="campo('condicao')"
          ><b-form-select
            :id="campo('condicao')"
            :value="value.indPag"
            :options="condicoes"
            :disabled="ocupado"
            @input="atualizar('indPag', $event)" /></b-form-group
      ></b-col>
      <b-col md="3"
        ><b-form-group label="Valor recebido (R$)" :label-for="campo('valor')"
          ><b-form-input
            :id="campo('valor')"
            :value="value.vPag"
            type="number"
            min="0.01"
            step="0.01"
            :disabled="ocupado"
            @input="atualizar('vPag', $event)"
            required /></b-form-group
      ></b-col>
      <b-col md="3"
        ><b-form-group label="Data do recebimento" :label-for="campo('data')"
          ><b-form-input
            :id="campo('data')"
            :value="value.dPag"
            type="date"
            :max="hoje"
            :disabled="ocupado"
            @input="atualizar('dPag', $event)"
            required /></b-form-group
      ></b-col>
    </b-row>
    <b-form-group
      v-if="value.tPag === '99'"
      label="Descrição do meio de pagamento"
      :label-for="campo('descricao')"
      ><b-form-input
        :id="campo('descricao')"
        :value="value.xPag"
        minlength="2"
        maxlength="60"
        :disabled="ocupado"
        @input="atualizar('xPag', $event)"
        required
    /></b-form-group>
    <b-alert :show="!!erroOperadoras" variant="warning"
      >{{ erroOperadoras }}
      <b-button size="sm" variant="link" @click="carregarOperadoras"
        >Tentar novamente</b-button
      ></b-alert
    >
    <details>
      <summary class="text-primary mb-3">
        Dados da transação e dos estabelecimentos
      </summary>
      <p class="text-muted">
        Os dados do processamento e do beneficiário são preenchidos com o
        emitente da nota.
      </p>
      <b-row>
        <b-col md="4"
          ><b-form-group
            label="CNPJ onde o pagamento foi processado"
            :label-for="campo('cnpj-pag')"
            ><b-form-input
              :id="campo('cnpj-pag')"
              :value="value.CNPJPag"
              maxlength="18"
              disabled /></b-form-group
        ></b-col>
        <b-col md="2"
          ><b-form-group
            label="UF do processamento"
            :label-for="campo('uf-pag')"
            ><b-form-select
              :id="campo('uf-pag')"
              :value="value.UFPag"
              :options="ufs"
              disabled /></b-form-group
        ></b-col>
        <b-col md="6"
          ><b-form-group
            label="CNPJ da instituição financeira / adquirente"
            :label-for="campo('cnpj-if')"
            ><b-form-input
              :id="campo('cnpj-if')"
              :value="value.CNPJIF"
              maxlength="18"
              :disabled="ocupado"
              @input="atualizar('CNPJIF', $event)" /></b-form-group
        ></b-col>
        <b-col md="8"
          ><b-form-group
            label="Autorização / identificador da transação"
            :label-for="campo('autorizacao')"
            ><b-form-input
              :id="campo('autorizacao')"
              :value="value.cAut"
              maxlength="128"
              :disabled="ocupado"
              @input="atualizar('cAut', $event)" /></b-form-group
        ></b-col>
        <b-col md="4"
          ><b-form-group
            label="Operadora / bandeira"
            :label-for="campo('bandeira')"
            description="Selecione o código e a operadora/bandeira da transação."
            ><b-form-select
              :id="campo('bandeira')"
              :value="value.tBand"
              :options="operadoras"
              :disabled="ocupado || carregandoOperadoras"
              @input="atualizar('tBand', $event)" /></b-form-group
        ></b-col>
        <b-col md="8"
          ><b-form-group
            label="CNPJ do beneficiário"
            :label-for="campo('cnpj-receb')"
            ><b-form-input
              :id="campo('cnpj-receb')"
              :value="value.CNPJReceb"
              maxlength="18"
              disabled /></b-form-group
        ></b-col>
        <b-col md="4"
          ><b-form-group
            label="UF do beneficiário"
            :label-for="campo('uf-receb')"
            ><b-form-select
              :id="campo('uf-receb')"
              :value="value.UFReceb"
              :options="ufs"
              disabled /></b-form-group
        ></b-col>
      </b-row>
    </details>
  </div>
</template>

<script>
import {
  hoje,
  MEIOS_PAGAMENTO,
  UFS,
  erroEconf,
} from "@/modules/NFe/services/econf";
export default {
  name: "EconfPagamentoForm",
  props: {
    value: { type: Object, required: true },
    indice: { type: Number, default: 0 },
    removivel: Boolean,
    ocupado: Boolean,
  },
  data() {
    return {
      hoje: hoje(),
      meios: MEIOS_PAGAMENTO,
      operadoras: [{ value: "", text: "Selecione a operadora / bandeira" }],
      carregandoOperadoras: false,
      erroOperadoras: "",
      condicoes: [
        { value: "0", text: "À vista" },
        { value: "1", text: "A prazo" },
      ],
      ufs: [
        { value: "", text: "Selecione" },
        ...UFS.map((uf) => ({ value: uf, text: uf })),
      ],
    };
  },
  created() {
    this.carregarOperadoras();
  },
  methods: {
    async carregarOperadoras() {
      this.carregandoOperadoras = true;
      this.erroOperadoras = "";
      try {
        const { data } = await this.$http.post("/nfe/bandeiras");
        this.operadoras = [
          { value: "", text: "Selecione a operadora / bandeira" },
          ...data.map((item) => ({
            value: String(item.id).padStart(2, "0"),
            text: `${String(item.id).padStart(2, "0")} - ${item.descricao}`,
          })),
        ];
      } catch (erro) {
        this.erroOperadoras = erroEconf(
          erro,
          "Não foi possível carregar as operadoras."
        );
      } finally {
        this.carregandoOperadoras = false;
      }
    },
    campo(nome) {
      return `econf-pag-${this.indice}-${nome}`;
    },
    atualizar(campo, valor) {
      this.$emit("input", { ...this.value, [campo]: valor });
    },
  },
};
</script>
